import React from 'react';
import styles from '../styles/liquidMetal.module.css';

const LiquidMetalButton = ({ onClick, disabled, isActive }) => {
  return (
    <button
      type="submit"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.liquidMetal} ${isActive ? styles.active : ''} ${disabled ? styles.disabled : ''}`}
      aria-label="Send message"
    >
      <svg 
        data-name="1-Arrow Up" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 32 32"
        className={styles.arrowIcon}
      >
        <path d="m26.71 10.29-10-10a1 1 0 0 0-1.41 0l-10 10 1.41 1.41L15 3.41V32h2V3.41l8.29 8.29z"/>
      </svg>
    </button>
  );
};

export default LiquidMetalButton;
